const menuModals: { [key: string]: string } = {
  "gantt_chart": "gantt",
  "map": "map",
  "settings": "settings",
  "reports": "report",
  "file_explorer": "settings",
  "as_built_tab": "settings",
  "as_planned_tab": "settings",
  "health": "health"
};

export default menuModals;